import { createSelector } from 'reselect';
import { getTranslate as getTranslateHelper, getActiveLanguage } from 'react-localize-redux';

const getLocale = state => state.localize;

const getTranslate = createSelector([getLocale], locale => {
    return getTranslateHelper(locale);
});

const getSelectedLanguage = createSelector([getLocale], locale => {
    const activeLanguage = getActiveLanguage(locale);
    return activeLanguage?.code || 'en';
});

export { getLocale, getTranslate, getSelectedLanguage };
